export default "__VITE_ASSET__ba62704b__"